import React from 'react'

import {
  generateHtmlLegendPlugin,
  generateLabels,
  generateTooltipLabel,
  getBookingChartLegendText,
} from './utils'

export default function BookingSourcesChart (props) {
  const { chartComponent: Chart, data = {} } = props

  const legendContainerId = 'booking-sources-chart-legend'

  const options = {
    plugins: {
      tooltip: {
        callbacks: {
          label: generateTooltipLabel
        }
      },
      htmlLegend: {
        containerID: legendContainerId
      },
      legend: {
        display: false,
        labels: {
          generateLabels: chart => generateLabels(chart, getBookingChartLegendText)
        }
      }
    }
  }

  const htmlLegendPlugin = generateHtmlLegendPlugin('htmlLegend', legendContainerId)

  return (
    <div className="grid grid-cols-1 sm:grid-cols-[2fr,1fr] gap-2 pt-2 px-2">
      <div className="w-full h-[22rem] sm:h-[24rem] flex justify-center
        items-center sm:m-auto">
        <Chart
          plugins={[htmlLegendPlugin]}
          options={options}
          data={data}
          type="pie"
        />
      </div>

      <div
        className="w-full h-full sm:h-[24rem] overflow-hidden"
        id={legendContainerId}
      />
    </div>
  )
}